// Простые функции для нормализации дат
// ВСЕГДА устанавливаем начало и конец дня

export const normalizeStartDate = (date, time = null) => {
  if (!date) return null;
  const normalized = new Date(date);
  
  if (time) {
    // Если передано время, используем его (ИСПРАВЛЕНО: ?? вместо ||)
    normalized.setHours(time.hours ?? 0, time.minutes ?? 0, 0, 0);
  } else {
    // По умолчанию начало дня
    normalized.setHours(0, 0, 0, 0);
  }
  
  return normalized;
};

export const normalizeEndDate = (date, time = null) => {
  if (!date) return null;
  const normalized = new Date(date);
  
  if (time) {
    // Если передано время, используем его (ИСПРАВЛЕНО: ?? вместо ||)
    normalized.setHours(time.hours ?? 23, time.minutes ?? 59, 59, 999);
  } else {
    // По умолчанию конец дня
    normalized.setHours(23, 59, 59, 999);
  }
  
  return normalized;
};

// Функции для работы с временем
export const parseTimeString = (timeStr) => {
  if (!timeStr) return null;
  const [hours, minutes] = timeStr.split(':').map(Number);
  return { hours: hours || 0, minutes: minutes || 0 };
};

export const formatTimeString = (hours, minutes) => {
  const h = String(hours || 0).padStart(2, '0');
  const m = String(minutes || 0).padStart(2, '0');
  return `${h}:${m}`;
};

export const getTimeFromDate = (date) => {
  if (!date) return null;
  return {
    hours: date.getHours(),
    minutes: date.getMinutes()
  };
};

// Для пресетов - возвращаем уже нормализованные даты
export const getDatePreset = (preset) => {
  const now = new Date();
  let start, end;

  switch (preset) {
    case 'today':
      start = new Date(now);
      end = new Date(now);
      break;
    case 'yesterday':
      start = new Date(now);
      start.setDate(start.getDate() - 1);
      end = new Date(start);
      break;
    case 'last3days':
      start = new Date(now);
      start.setDate(start.getDate() - 3);
      end = new Date(now);
      break;
    case 'last7days':
      start = new Date(now);
      start.setDate(start.getDate() - 7);
      end = new Date(now);
      break;
    case 'last30days':
      start = new Date(now);
      start.setDate(start.getDate() - 30);
      end = new Date(now);
      break;
    case 'last90days':
      start = new Date(now);
      start.setDate(start.getDate() - 90);
      end = new Date(now);
      break;
    default:
      return { start: null, end: null };
  }

  return {
    start: normalizeStartDate(start),
    end: normalizeEndDate(end)
  };
};
